import { useEffect, useState, useContext, useMemo } from "react";
import 'react-quill/dist/quill.snow.css';
import _ from 'lodash';
import { Image, Tabs, } from "antd";
import moment from "moment";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { Modal as AntModal } from "antd";
import Linkify from 'react-linkify';
import {
    MainContainer,
    ChatContainer,
    MessageList,
    Message,
    MessageSeparator,
    AttachmentButton,
    Loader,
} from "@chatscope/chat-ui-kit-react";
import { db, storage, } from "../utils/firebase";
import { ChatRefContext } from '../context/chatRef.context';
import { getSignedUrlForFile } from "../utils/actions/allactions";
import jwt_decode from "jwt-decode";
import { Offcanvas } from "react-bootstrap";
import ReactQuill from "react-quill";
import { useInstance } from "../context/instance.context";
import { DeleteIcon, LucidLoader } from "../components/Icons";
import PDFModalViewer from "../components/PDFViewerModal/PDFModalViewer";



function isEditorContentEmpty(html) {
    const cleaned = html
        .replace(/<p><br><\/p>/gi, '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, '')
        .trim();

    return cleaned.length === 0;
}


function Chat({ onDrawerClose }) {
    let { selectedChatRefId, setSelectedChatRefId, chatType } = useContext(ChatRefContext);
    const [chatStyle, setChatStyle] = useState(null);
    let localSelectedChatRefId = selectedChatRefId;
    const [isClosedChat, setIsClosedChat] = useState(false);
    const oldRefId = selectedChatRefId;
    if (localSelectedChatRefId) {
        localSelectedChatRefId = localSelectedChatRefId.split(' ')[0];
        if (localSelectedChatRefId.startsWith('S')) {
            localSelectedChatRefId = localSelectedChatRefId.slice(1)
        }
    }
    const { organizationName } = useInstance();


    // console.log("selectedahcat ref",selectedChatRefId)
    if (selectedChatRefId) {
        let newSelectedChatRefId = selectedChatRefId.split(' ')[0];
        if (selectedChatRefId.startsWith('S')) {
            newSelectedChatRefId = newSelectedChatRefId.slice(1)
            setSelectedChatRefId(newSelectedChatRefId)
        }
    }
    console.log("Selected Cat Ref Id :", selectedChatRefId);
    let loggedInUserFirstName = localStorage.getItem('firstName');
    let loggedInUserLastName = localStorage.getItem('lastName');
    const [downloadAttachmentIndex, setDownloadAttachmentIndex] = useState(null);
    const [downloadAttachmentIndexAttachmentSection, setDownloadAttachmentIndexAttachmentSection] = useState(null);
    const [pdfModalInfo, setPdfModalInfo] = useState({
        show: false,
        fileName: '',
        pdfUrl: ''
    });

    const [addingAttachment, setAddAttachment,] = useState(false);
    const [attachments, setAttachments] = useState([]);
    let token = localStorage.getItem("Token");
    let decodedJwt = {};
    if (token) {
        decodedJwt = jwt_decode(token)
    }
    console.log("JWT Data :", decodedJwt);

    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [keys, setKeys] = useState([]);


    const onClose = () => {
        // setOpen(false);
        if (selectedChatRefId)
            db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).update({
                isOnline: false,
                RefId: selectedChatRefId,
                email: decodedJwt.email,
                firstName: loggedInUserFirstName || decodedJwt?.firstName,
                lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                lastOnline: new Date().toString()
            });
        onDrawerClose();
        setSelectedChatRefId(null);
    };

    console.log('RefId in chat component:', selectedChatRefId);

    const onSend = async (attachmentUrl = null, attachmentName = null) => {
        try {
            console.log('On send click message', selectedChatRefId, "   fsafsa");
            console.log('message', message);
            console.log('AttachmentUrl', attachmentUrl);
            if ((isEditorContentEmpty(message) || !message) && !attachmentUrl) {
                console.warn("Cannot send an empty message.");
                return;
            }

            if (selectedChatRefId) {
                const snapshot = await db.ref('/count/' + selectedChatRefId).get();
                let count = 0;
                if (snapshot.exists()) {
                    count = snapshot.val();
                } else {
                    count = 0;
                }
                const msgId = new Date().getTime()
                const messageObj = {
                    text: !attachmentUrl ? message : null,
                    type: attachmentUrl ? "attachment" : "text",
                    attachmentName: attachmentName,
                    createdon: new Date().toString(),
                    userid: decodedJwt._id,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    url: attachmentUrl
                }

                console.log("Message Object :", messageObj);
                if (messageObj.text === '') return;
                db.ref('/messages/' + selectedChatRefId + '/' + msgId).set(messageObj)
                    .then((something) => console.log('Message sent successfully:', something))
                    .catch(err => console.log("Error in mesafe send", err));
                db.ref('/count/' + selectedChatRefId).set(count + 1);

                // console.log('----------3---------')
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                    msgId: msgId,
                    count: count + 1,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                });
                db.ref("/timings/" + selectedChatRefId).update({
                    lastOnline: new Date().toString(),
                    isEveryoneOffline: false,
                });
                if (!attachmentUrl) {
                    setMessage("")
                }

                console.log("Cam here after sending message");
            }
        }
        catch (err) {
            console.log("err", err)
        }

    }

    const onChange = (value) => {
        setMessage(value)
    }

    const handleKeySort = (arrayToSort,) => {
        let data = [...arrayToSort].sort((a, b) => {
            return moment(a).isAfter(b) ? 1 : -1
        });
        return data;
    }

    useEffect(() => {
        if (selectedChatRefId) {
            // console.log('--------c---------',RefId)
            // console.log('----------1---------')
            db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).get().then(async snapshot => {
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).onDisconnect().update({
                    isOnline: false,
                    RefId: selectedChatRefId,
                    lastOnline: new Date().toString()
                });

                let value = {
                    count: 0,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                };

                if (snapshot.exists()) {
                    value = snapshot.val();
                }

                const snapshotVal = await db.ref('/count/' + selectedChatRefId).get();

                if (snapshotVal.exists()) {
                    const count = snapshotVal.val();
                    value.count = count;
                }

                // console.log('----------2---------')
                db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                    ...value,
                    isOnline: true,
                    RefId: selectedChatRefId,
                    email: decodedJwt.email,
                    firstName: loggedInUserFirstName || decodedJwt?.firstName,
                    lastName: loggedInUserLastName || decodedJwt?.lastName || "",
                    lastOnline: new Date().toString()
                })
                db.ref("/timings/" + selectedChatRefId).update({
                    lastOnline: new Date().toString(),
                    isEveryoneOffline: false,
                });
            });

            if (chatType == 'customer') {
                setChatStyle(null)
            } else if (chatType == 'supplier') {
                setChatStyle({
                    backgroundColor: '#f3ceb6',
                    color: '#6e3815'
                })
            }
        }
    }, [selectedChatRefId])

    useEffect(() => {
        if (selectedChatRefId) {
            const ref = db.ref('/messages/' + selectedChatRefId);
            const onValueChange = (snapshot) => {
                const data = snapshot.val();
                let messagesArr = [];
                if (data) {
                    const updatedData = {};
                    Object.keys(data).forEach((key) => {
                        const innerObj = data[key];
                        innerObj.key = key;
                        updatedData[key] = innerObj;
                    });
                    messagesArr = Object?.values(updatedData);
                }


                // Use a single, consistent date format for grouping
                const property = 'createdon';
                const array = messagesArr.map(mess => {
                    const date = new Date(mess.createdon);
                    return {
                        ...mess,
                        'createdon': moment(mess.createdon).format('MMM DD, YYYY'),
                        'time': date.getHours() + ':' + (date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes())
                    }
                });
                const arr = array.reduce(function (groups, item) {
                    var name = item[property]
                    var group = groups[name] || (groups[name] = []);
                    group.push(item);
                    return groups;
                }, {});
                console.log("Arr ::", arr);

                const keysArr = Object.keys(arr);
                const sortedKey = handleKeySort(keysArr);
                console.log("Sorted key ::", sortedKey);
                setKeys(sortedKey);
                setMessages(arr);
            };

            ref.on('value', onValueChange);

            // Cleanup: remove listener on unmount or when selectedChatRefId changes
            return () => {
                ref.off('value', onValueChange);
            };
        }
    }, [selectedChatRefId])

    // Helper to extract attachments from messages
    const extractAttachments = (messagesObj, keysArr) => {
        let arr = [];
        keysArr.forEach(key => {
            if (messagesObj[key]) {
                messagesObj[key].forEach(message => {
                    if (message.type === "attachment") {
                        arr.push(message);
                    }
                });
            }
        });
        return arr;
    };

    // Update attachments whenever messages or keys change
    useEffect(() => {
        setAttachments(extractAttachments(messages, keys));
    }, [messages, keys]);

    const uploadFiles = (file, e) => {
        if (!file) return;
        try {
            setAddAttachment(true);
            let fileNameForDownload = `${Date.now()}_${file.name}`;
            const uploadTask = storage.ref(`/files/${fileNameForDownload}`).put(file);

            uploadTask.on("state_changed", (snapshot) => {
                const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                // setProgress(prog);
            },
                (err) => console.log(err),
                async () => {
                    await onSend(fileNameForDownload, file.name);
                    setAddAttachment(false);
                    // After upload, refresh attachments
                    setAttachments(extractAttachments(messages, keys));
                }
            )
        } catch (err) {
            console.log('something went wrong', err)
        }
    }

    const handleFileDownload = async (fileNameForDownload, fileName, j, type) => {
        if (type == 'chat') {
            setDownloadAttachmentIndex(j);
        }
        else {
            setDownloadAttachmentIndexAttachmentSection(j);
        }
        try {

            const responseType = fileName.endsWith('.pdf') ? 'json' : 'blob';
            console.log('fileNameForDownload', fileName, responseType);
            const encodedURL = encodeURIComponent(fileNameForDownload);
            const response = await getSignedUrlForFile(encodedURL, responseType);
            if (responseType === 'json') {
                const { signedUrl } = response.data;
                setPdfModalInfo({
                    show: true,
                    fileName: fileName,
                    pdfUrl: signedUrl
                });
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.log('err', err)
        } finally {
            if (type == 'chat') {
                setDownloadAttachmentIndex(null);
            }
            else {
                setDownloadAttachmentIndexAttachmentSection(null);
            }
        }
    }

    const attachFunc = () => {
        let upload = false;
        const fileUploader = document.getElementById('file-uploader');
        fileUploader.click();
        fileUploader.addEventListener('change', (event) => {
            if (upload === true) return;
            const files = event.target.files[0];
            uploadFiles(files);
            upload = true;
            fileUploader.value = null;
        });
    }

    const tabsChange = (key) => {
        if (key === '2') {
            let arr = [];
            keys.map(key => messages[key].filter(message => {
                if (message.type === "attachment") {
                    arr = [...arr, message];
                }
            }));
            setAttachments(arr);
        }
    };

    const name = (message) => {
        console.log('message.email', message?.email, message)
        if (message?.firstName && message?.lastName && message?.lastName != 'undefined' && message?.email.includes(`${organizationName?.split(" ")?.pop()?.toLowerCase()}`)) {
            return message.firstName + ' ' + (message?.lastName || "") + ` (${organizationName?.split(" ")?.pop()?.toLowerCase() || ""})`;
        } else if (message?.firstName && (message?.lastName || "") && message?.lastName != 'undefined') {
            return message.firstName + ' ' + (message.lastName || "");
        } else {
            return message.firstName;
        }
    };

    const handleMessageDelete = async (message) => {
        try {
            setIsClosedChat(true);
            let adminResponse = await new Promise((resolve) => {
                AntModal.confirm({
                    title: 'Delete Message',
                    content: 'Are you sure you want to delete the message?',
                    okText: 'Yes',
                    cancelText: 'No',
                    okType: 'danger', // highlights this as a destructive action
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                });
            });
            if (!adminResponse) return;
            setIsClosedChat(false);

            await db.ref('/messages/' + selectedChatRefId + '/' + message.key).remove();

            const countSnapshot = await db.ref("/count/" + selectedChatRefId).once("value");
            const count = countSnapshot.val() || 0;
            await db.ref('/count/' + selectedChatRefId).set(count - 1);

            const userSnapShot = await db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).get();
            const userData = userSnapShot.val();

            await db.ref('/users/' + selectedChatRefId + '/' + decodedJwt._id).set({
                ...userData,
                count: count - 1,
            });

        } catch (err) {
            console.log("Error", err);
        }
    }

    const isLink = (text) => {
        if (typeof text !== 'string') return false;
        const plainText = text.replace(/<[^>]+>/g, '').trim();
        return /^https?:\/\/[^\s]+$/i.test(plainText);
    };

    const getLinkText = (text) => {
        if (typeof text !== 'string') return '';
        return text.replace(/<[^>]+>/g, '').trim();
    };

    console.log("messages ::", messages);
    const items = useMemo(() => [
        {
            key: '1',
            label: `Chat`,
            children: keys.map((key, i) => (
                <div key={i}>
                    <MessageSeparator content={key} />
                    {messages[key]?.map((message, j) => (
                        <div key={j}>
                            <div className="flex justify-end items-center">
                                <Message
                                    model={{
                                        sentTime: message.createdon,
                                        sender: message.email,
                                        position: "single",
                                        type: 'html',
                                        direction: message.userid === decodedJwt._id ? "outgoing" : "incoming"
                                    }}
                                >
                                    <Message.CustomContent>
                                        {isLink(message?.text) ? (
                                            <a
                                                href={getLinkText(message.text)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "#2995DB", textDecoration: "underline" }}
                                            >
                                                {getLinkText(message.text)}
                                            </a>
                                        ) : (
                                            <Linkify
                                                componentDecorator={(decoratedHref, decoratedText, key) => (
                                                    <a target="_blank" rel="noopener" href={decoratedHref} key={key}>
                                                        {decoratedText}
                                                    </a>
                                                )}
                                            >
                                                <Message.HtmlContent
                                                    html={
                                                        message?.text?.replaceAll("&lt;", "<")?.replaceAll("&gt;", ">") ||
                                                        message.attachmentName
                                                    }
                                                />
                                            </Linkify>
                                        )}
                                    </Message.CustomContent>

                                    {message.type === "attachment" && (
                                        <Message.CustomContent>
                                            <div>
                                                {(message?.url?.toLowerCase()?.includes("png") ||
                                                    message?.url?.toLowerCase()?.includes("jpg") ||
                                                    message?.url?.toLowerCase()?.includes("jpeg") ||
                                                    message?.url?.toLowerCase()?.includes("webp")) ? (
                                                    <Image
                                                        src={`${process.env.REACT_APP_API_ENDPOINT}/comman/get-signed-url-for-file-name/` + message.url}
                                                        width="200px"
                                                    />
                                                ) : (
                                                    <div
                                                        style={{
                                                            background: "white",
                                                            padding: "8px",
                                                            borderRadius: 8,
                                                            textAlign: "center",
                                                            minWidth: 160,
                                                            marginBottom: 8
                                                        }}
                                                    >
                                                        <p className="text" style={{ fontWeight: 700 }}>
                                                            {message.attachmentName}
                                                        </p>
                                                    </div>
                                                )}
                                                {downloadAttachmentIndex !== j ? (
                                                    <p
                                                        onClick={() =>
                                                            handleFileDownload(message.url, message.attachmentName, j, "chat")
                                                        }
                                                        style={{ cursor: "pointer", color: "#2995DB" }}
                                                    >
                                                        Download
                                                    </p>
                                                ) : (
                                                    <div className="flex items-center justify-center">
                                                        <LucidLoader />
                                                    </div>
                                                )}
                                            </div>
                                        </Message.CustomContent>
                                    )}
                                </Message>
                                {decodedJwt?.userType === "admin" && message.userid === decodedJwt._id && (
                                    <span onClick={() => handleMessageDelete(message)}>
                                        <DeleteIcon additionalClasses="!text-red-500" />
                                    </span>
                                )}
                            </div>
                            <div>
                                <div
                                    className={
                                        message.userid === decodedJwt._id
                                            ? "outgoing !text-[12px] !mt-[4px]"
                                            : "incoming !text-[12px] !mt-[4px]"
                                    }
                                    style={{ margin: "-5px 0px 15px 0px" }}
                                >
                                    {name(message)}, {message.time}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ))
        },
        {
            key: '2',
            label: `Attachments`,
            children: attachments.length
                ? attachments.map((item, index) => (
                    <Message
                        key={index}
                        model={{
                            message: item.attachmentName,
                            sentTime: item.createdon,
                            sender: item.email,
                            position: "single",
                            type: "text",
                            direction: item.userid === decodedJwt._id ? "outgoing" : "incoming"
                        }}
                    >
                        <Message.CustomContent>
                            <div>
                                {(item?.url?.toLowerCase()?.includes("png") ||
                                    item?.url?.toLowerCase()?.includes("jpg") ||
                                    item?.url?.toLowerCase()?.includes("jpeg") ||
                                    item?.url?.toLowerCase()?.includes("webp")) ? (
                                    <Image
                                        src={`${process.env.REACT_APP_API_ENDPOINT}/comman/get-signed-url-for-file-name/` + item.url}
                                        width="200px"
                                    />
                                ) : (
                                    <div
                                        style={{
                                            background: "white",
                                            padding: "8px",
                                            borderRadius: 8,
                                            textAlign: "center",
                                            minWidth: 160,
                                            marginBottom: 8
                                        }}
                                    >
                                        <p className="text" style={{ fontWeight: 700 }}>
                                            {item.attachmentName}
                                        </p>
                                    </div>
                                )}
                                {downloadAttachmentIndexAttachmentSection !== index ? (
                                    <p
                                        onClick={() =>
                                            handleFileDownload(item.url, item.attachmentName, index, "att")
                                        }
                                        style={{ cursor: "pointer", color: "#2995DB" }}
                                    >
                                        Download
                                    </p>
                                ) : (
                                    <div className="flex items-center justify-center">
                                        <LucidLoader />
                                    </div>
                                )}
                            </div>
                        </Message.CustomContent>
                    </Message>
                ))
                : null
        }
    ], [
        keys,
        messages,
        attachments,
        addingAttachment,
    ]);



    return (
        <>
            <div>
                <Offcanvas
                    placement="end"
                    show={isClosedChat ? false : selectedChatRefId?.length}
                    onHide={onClose}
                    style={{ width: "35%" }}
                    className="chat-drawer"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title className="sub-header">
                            RefId: {oldRefId}
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className="chat-div" style={{ position: "relative", zIndex: 1 }}>
                            <MainContainer>
                                <ChatContainer>
                                    <MessageList autoScrollToBottom={true} autoScrollToBottomOnMount={true}>
                                        <div style={{ position: "relative", height: "100%" }}>
                                            {addingAttachment && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundColor: "rgba(255, 255, 255, 0.8)", // overlay background
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <Loader>Uploading Attachment ...</Loader>
                                                </div>
                                            )}

                                            <Tabs
                                                tabPosition="top"
                                                defaultActiveKey="1"
                                                items={items}
                                                onChange={tabsChange}
                                            />
                                        </div>
                                    </MessageList>
                                </ChatContainer>
                            </MainContainer>
                            <div className="input-div">
                                <input
                                    type="file"
                                    id='file-uploader'
                                    style={{ display: 'none' }}
                                // onChange={(e) => {attachFunc(e)}} 
                                />
                                <AttachmentButton className="attachment-btn" onClick={attachFunc} />
                                <ReactQuill
                                    message={message}
                                    onChange={onChange}
                                    value={message}
                                    className="!h-auto"
                                />
                                <div className="btn-div flex gap-2 mt-2">
                                    <button
                                        className="border-btn"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="primary-btn w-100 text-white"
                                        onClick={() => {
                                            onSend()
                                        }}
                                    >
                                        Send
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
                <PDFModalViewer
                    show={pdfModalInfo.show}
                    handleClose={() => setPdfModalInfo({ show: false, fileName: '', pdfUrl: '' })}
                    fileName={pdfModalInfo.fileName}
                    pdfUrl={pdfModalInfo.pdfUrl}

                />
            </div>
        </>
    );
}

export default Chat;
